import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-datatable',
  templateUrl: './empty-datatable.component.html',
  styleUrls: ['./empty-datatable.component.scss']
})
export class EmptyDatatableComponent {
  @Input() message: string = 'No records available';
  @Input() hint?: string;
}
